// //TESTs
// require("./footer")

const btnpaises = document.querySelectorAll('footer .contenedor .pais.active')

function cerrartodo(){
    btnpaises.forEach(btnpais => {
        btnpais.querySelector('.popupdireccion').classList.remove('active')
    });
}

btnpaises.forEach(btnpais => {
    let cerrar = btnpais.querySelector('.popupdireccion .cerrar')
    let nombrepais = btnpais.querySelector('p')
    nombrepais.addEventListener('click',()=>{
        cerrartodo()
        btnpais.querySelector('.popupdireccion').classList.add('active')
    })
    cerrar.addEventListener('click', ()=>{
        console.log('cerrar');
        btnpais.querySelector('.popupdireccion').classList.remove('active')
    })
});